import { html, attr } from '@tempots/dom'
import { Icon } from '@tempots/beatui'
import type { TNode } from '@tempots/dom'

export interface LoadingStateOptions {
  message?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Reusable loading spinner component
 *
 * @example
 * When(loading, () => LoadingState({ message: 'Loading files...' }))
 */
export function LoadingState(options: LoadingStateOptions = {}): TNode {
  const { message = 'Loading...', size = 'md' } = options

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  }

  const paddingClasses = {
    sm: 'py-4',
    md: 'py-8',
    lg: 'py-12',
  }

  return html.div(
    attr.class(`flex items-center justify-center ${paddingClasses[size]}`),
    html.div(
      attr.class('flex items-center gap-3'),
      Icon(
        { icon: 'mdi:loading' },
        attr.class(`${sizeClasses[size]} text-brand-600 animate-spin`)
      ),
      html.span(attr.class('text-gray-600'), message)
    )
  )
}
